import { render, staticRenderFns } from "./app-nav-drawer.vue?vue&type=template&id=5439f380&"
import script from "./app-nav-drawer.component.ts?vue&type=script&lang=ts&"
export * from "./app-nav-drawer.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports